<script setup lang="ts">
import { SignatureDocumentFieldType } from '@/store/enums';
import { DateTime } from 'luxon';
import {onMounted, Ref, ref, computed} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";
import {useRootStore} from "@/store";

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();

const rootStore = useRootStore();
const facilityTimeZone = computed(() => rootStore.state.facility?.ianaTimeZoneName || 'system');

const value = ref(DateTime.now().setZone(facilityTimeZone.value).toLocaleString(DateTime.DATETIME_SHORT));

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) => 
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.DateTime, value})
);
</script>

<template>
    <div>
        <p-input-text
            size="small"
            readonly
            disabled
            class="datetime-input"
            :val="value"
            :value="value"
        />
        <span class="signature-form-data signature-form-datetime-signed">
            {{ value }}
        </span>
    </div>
</template>

<style scoped lang="scss">
    .datetime-input.p-inputtext {
        width: 180px;
    }
</style>
